import { apiRequest } from "@/features/api/apiClient";
import type {
  CreateBillingPortalSessionResponse,
  CreateCheckoutSessionResponse,
  StripeCheckoutProductType,
} from "@shared/types";

export function createCheckoutSession(
  token: string | null,
  productType: StripeCheckoutProductType,
): Promise<CreateCheckoutSessionResponse> {
  return apiRequest<CreateCheckoutSessionResponse>("/api/billing/checkout", {
    method: "POST",
    token,
    body: {
      productType,
    },
  });
}

export function openBillingPortal(
  token: string | null,
): Promise<CreateBillingPortalSessionResponse> {
  return apiRequest<CreateBillingPortalSessionResponse>("/api/billing/portal", {
    method: "POST",
    token,
  });
}
